import { TFunction } from 'i18next';
import { Popover } from '@/components/Popover';
import { ResultPhotoLegend } from './ResultPhotoLegend';
import { useGetAllRepairServicesByEquipmentDamage } from '@/hooks/repair-costing.hooks';

type RepairCostingWithService = {
  cost?: number;
  repairService?: { id: string; name: string };
};

interface RepairCostingDetailsProps {
  t?: TFunction<undefined>;
  equipmentId?: string;
  equipmentClassId?: number;
  damageId?: string;
  damageClassId?: number;
}

export const RepairCostingDetails = ({
  t,
  equipmentId,
  equipmentClassId,
  damageId,
  damageClassId,
}: RepairCostingDetailsProps) => {
  const { data: repairCostings, isLoading } =
    useGetAllRepairServicesByEquipmentDamage({
      equipmentId,
      equipmentClassId,
      damageId,
      damageClassId,
    });

  const repairOptions: RepairCostingWithService[] = repairCostings?.data || [];

  if (isLoading) {
    return <>{`${t('common:loading')}...`}</>;
  }

  if (!repairOptions?.length) {
    return (
      <div className="-mt-0.5 px-[9px] py-0.75 text-primary text-xs border border-primary rounded-[5px]">
        {t('common:noData')}
      </div>
    );
  }

  return (
    <Popover
      containerClassName="-mt-0.5"
      titleClassName="px-[9px] py-1 text-white text-xs bg-primary rounded-[5px]"
      contentClassName="px-4 py-2"
      title={t('common:view')}
    >
      {repairOptions?.map((rep, index) => (
        <div key={index} className="grid grid-cols-2">
          <ResultPhotoLegend
            fieldText={`${rep?.repairService?.name} :`}
            valueText=""
          />
          <ResultPhotoLegend
            containerClassName="justify-center"
            fieldText=""
            valueText={`${rep?.cost} Euros`}
          />
        </div>
      ))}
    </Popover>
  );
};
